import {
  SURVEY_SOURCE_LANGUAGE,
  SURVEY_TRANSLATION_LANGUAGE_LABELS,
  SURVEY_TRANSLATION_NATIVE_LANGUAGE_LABELS,
} from '@constants';

export const normalizeSurveyLanguageCode = (languageCode) => {
  const value = typeof languageCode === 'string' ? languageCode.trim() : '';
  return typeof value === 'string' && value.trim() ? value.trim() : undefined;
};

const getSurveyLanguageLabel = (languageCode, labelMap = {}) =>
  labelMap[languageCode] || languageCode;

export const getSurveyLanguageSelection = (languageInfo, { fallbackSourceLanguage } = {}) => {
  const originalLanguage = normalizeSurveyLanguageCode(languageInfo?.originalLanguage);
  const translatedLanguages = [];
  const seenTranslatedLanguages = new Set();

  (languageInfo?.translatedLanguages || []).forEach((entry) => {
    const languageCode = normalizeSurveyLanguageCode(entry);
    if (!languageCode || seenTranslatedLanguages.has(languageCode)) return;
    seenTranslatedLanguages.add(languageCode);
    translatedLanguages.push(languageCode);
  });

  const sourceLanguage = originalLanguage || fallbackSourceLanguage;
  const languages = sourceLanguage
    ? [sourceLanguage, ...translatedLanguages.filter((language) => language !== sourceLanguage)]
    : translatedLanguages;

  return {
    languages,
    originalLanguage,
    sourceLanguage,
    translatedLanguages,
  };
};

export const getOrderedSurveyLanguages = (languageInfo) =>
  getSurveyLanguageSelection(languageInfo, {
    fallbackSourceLanguage: SURVEY_SOURCE_LANGUAGE,
  }).languages;

export const getSurveyLanguageOptions = (
  languageInfo,
  { includeOriginalLanguage = false, labelMap = {} } = {}
) => {
  const translatedEntries = languageInfo?.translatedLanguages || [];
  if (!translatedEntries.length) return [];

  const entries = [
    ...(includeOriginalLanguage && languageInfo?.originalLanguage
      ? [languageInfo.originalLanguage]
      : []),
    ...translatedEntries,
  ];
  const seen = new Set();
  const options = [];

  entries.forEach((entry) => {
    const value = normalizeSurveyLanguageCode(entry);
    if (!value || seen.has(value)) return;
    seen.add(value);
    options.push({
      label: getSurveyLanguageLabel(value, labelMap),
      value,
    });
  });

  return options;
};

export const getSurveyLanguageDropdownOptions = (languages = []) =>
  languages.map((language) => ({
    label: SURVEY_TRANSLATION_LANGUAGE_LABELS[language] ?? language,
    value: language,
  }));

export const getSurveyNativeLanguageLabel = (language) =>
  SURVEY_TRANSLATION_NATIVE_LANGUAGE_LABELS[language] ?? language;
